export const globalVars = 
    {DE: 
        {productName: 'EsGehtMirGut.ch'}, 
    EN: 
        {productName: 'EsGehtMirGut.ch'},
    serverless:
        {apiUrl: 'https://ue22b2pwj2.execute-api.eu-central-1.amazonaws.com/dev'},
    };